module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Smoke and Mirrors")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("The first book of a new series")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("is always for")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("David.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("This one is no exception.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0